module.exports = __webpack_public_path__ + "static/media/1-outdoor.4b85a0bf.webp";